import isEmpty from 'is-empty';
import totalAsset from './totalAsset';

export default function findPercentInAssets(symbol, assets, currencies, type = '') {
  if (isEmpty(assets) || isEmpty(currencies)) return 0;
  let total = totalAsset(assets, currencies);
  let asset = isEmpty(type)
    ? assets.find((item) => item.currencySymbol === symbol)
    : assets.find((item) => item.currencySymbol === symbol && item?.tokenType === type);
  if (isEmpty(asset)) return 0;
  let coresspondingCurrency = currencies.find((item) => item.symbol === asset.currencySymbol);

  let val = parseFloat((((asset.balance * coresspondingCurrency.price) / total) * 100).toFixed(2))
  return isNaN(val) ? 0 : val ;
}
